/* eslint-disable react/prop-types */
import React from 'react';

const display = (val, fallback = '—') => (val == null || val === '' ? fallback : String(val));

/**
 * Downtime strip matching backend one-page PDF template (dt-layout).
 * Today total | per-category today + to-date | project to-date.
 */
export default function OnePageDowntimeBlock({
  rows = [],
  columnTotals = {},
  projectToDateMin,
  classPrefix = 'op',
}) {
  const p = classPrefix;
  const todayTotal = columnTotals?.today;

  return (
    <div className={`${p}-dt-layout`}>
      <div className={`${p}-dt-anchor`}>
        <div className={`${p}-dt-anchor-lbl`}>Today Downtime</div>
        <div className={`${p}-dt-anchor-val`}>{display(todayTotal, '0')}</div>
      </div>
      <div className={`${p}-dt-groups`}>
        {rows.map((row, idx) => (
          <div key={row.label ?? idx} className={`${p}-dt-grp`}>
            <div className={`${p}-dt-grp-lbl`}>{display(row.label)}</div>
            <div className={`${p}-dt-grp-cells`}>
              <div className={`${p}-dt-cell`}>
                <span className={`${p}-dt-cell-lbl`}>Today</span>
                <strong>{display(row.today, '0')}</strong>
              </div>
              <div className={`${p}-dt-cell`}>
                <span className={`${p}-dt-cell-lbl`}>To Date</span>
                <strong>{display(row.toDate, '0')}</strong>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className={`${p}-dt-anchor ${p}-dt-anchor-right`}>
        <div className={`${p}-dt-anchor-lbl`}>To Date Project Downtime</div>
        <div className={`${p}-dt-anchor-val`}>{display(projectToDateMin, '0')}</div>
      </div>
    </div>
  );
}
